import React from 'react';
import { Col, Label, Row } from 'reactstrap';
import _ from 'lodash';
import {
  TextInput,
  BooleanInput,
  Select,
  // @ts-ignore
} from 'flaivy-react/components/inputs';

const IntercomConfigEditor = ({
  value,
  onChange,
  name,
}: {
  value: object;
  onChange: Function;
  name: string;
}) => {
  const handleChange = (key: string, inputValue: string) =>
    onChange(name, {
      ...value,
      [key]: inputValue,
    });
  return (
    <Row>
      <Col xs={4} className="my-3">
        <Label>
          Intercom app id
          <TextInput
            name="appId"
            value={_.get(value, 'appId', '')}
            onChange={handleChange}
          />
        </Label>
      </Col>
      <Col xs={4} className="my-3">
        <Label>
          Bakgrundsfärg
          <input
            className="d-block"
            type="color"
            name="backgroundColor"
            value={_.get(value, 'backgroundColor')}
            onChange={e => handleChange(e.target.name, e.target.value)}
          />
        </Label>
      </Col>
      <Col xs={4} className="my-3">
        <Label>
          Accentfärg
          <input
            className="d-block"
            type="color"
            name="actionColor"
            value={_.get(value, 'actionColor')}
            onChange={e => handleChange(e.target.name, e.target.value)}
          />
        </Label>
      </Col>
    </Row>
  );
};
const ZendeskConfigEditor = ({
  value,
  onChange,
  name,
}: {
  value: object;
  onChange: Function;
  name: string;
}) => {
  const handleChange = (key: string, inputValue: string) =>
    onChange(name, {
      ...value,
      [key]: inputValue,
    });
  return (
    <Row>
      <Col xs={4} className="my-3">
        <Label>
          Zendesk nyckel
          <TextInput
            name="zendeskKey"
            value={_.get(value, 'zendeskKey', '')}
            onChange={handleChange}
          />
        </Label>
      </Col>
    </Row>
  );
};

function ChatConfigEditor({
  value,
  onChange,
  name,
}: {
  value: any;
  onChange: Function;
  name: string;
}) {
  const handleChange = (key: string, inputValue: string | object) => {
    onChange('chatConfig', {
      ...value,
      [key]: inputValue,
    });
  };

  return (
    <Row>
      <Col sm={12}>
        <Label>
          Använd chat
          <BooleanInput
            onChange={handleChange}
            value={_.get(value, 'useChat', false)}
            name="useChat"
            setValue={() => {}}
          />
        </Label>
      </Col>
      {_.get(value, 'useChat') && (
        <>
          <Col sm={12}>
            <Label className="w-25">
              Chat integration
              <Select
                type="string"
                instanceId="chatIntegration"
                name="chatIntegration"
                placeholder="Välj chat integration"
                value={_.get(value, 'chatIntegration', '')}
                onChange={handleChange}
                options={[
                  { label: 'Intercom', value: 'intercom' },
                  { label: 'Zendesk', value: 'zendesk' },
                ]}
              />
            </Label>
          </Col>
          {_.get(value, 'chatIntegration') === 'intercom' && (
            <IntercomConfigEditor
              value={value.intercomConfig}
              onChange={handleChange}
              name="intercomConfig"
            />
          )}
          {_.get(value, 'chatIntegration') === 'zendesk' && (
            <ZendeskConfigEditor
              value={value.zendeskConfig}
              onChange={handleChange}
              name="zendeskConfig"
            />
          )}
        </>
      )}
    </Row>
  );
}

export default ChatConfigEditor;
